import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "field-name p-pb-2",
      style: {"white-space":"pre-wrap"}
    }, _toDisplayString(_ctx.fieldName), 9 /* TEXT, PROPS */, _hoisted_2),
    _createVNode(_component_AutoComplete, _mergeProps({
      modelValue: _ctx.selectedAddress,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAddress) = $event))
    }, _ctx.$attrs, {
      id: _ctx.id,
      suggestions: _ctx.suggestedAddress,
      placeholder: _ctx.placeholder,
      forceSelection: true,
      delay: 800,
      "min-length": 3,
      field: (e) => e.address,
      onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchAddress($event))),
      onClear: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', ''))),
      onItemSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSuggestionSelected($event.value)))
    }), {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", null, _toDisplayString(slotProps.item.text), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 16 /* FULL_PROPS */, ["modelValue", "id", "suggestions", "placeholder", "field"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        key: error.$message
      }, [
        (_ctx.isDirty)
          ? (_openBlock(), _createElementBlock("small", {
              key: 0,
              id: _ctx.id,
              class: "p-error"
            }, _toDisplayString(error.$message), 9 /* TEXT, PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}